import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutJordan from "./sections/AboutJordan";
import OurServices from "./sections/OurServices";
import ContactBooking from "./sections/ContactBooking";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutJordan />
      <OurServices />
      <ContactBooking />
      <Footer />
    </div>;
}